import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from 'antd';
const { Content } = Layout;
export const AuthLayout = ({ children, title, subtitle }) => {
    return (_jsx(Layout, { style: { minHeight: '100vh' }, children: _jsx(Content, { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
            }, children: _jsxs("div", { style: { width: 420 }, children: [title && _jsx("h2", { style: { marginBottom: 8 }, children: title }), subtitle && _jsx("div", { style: { marginBottom: 16, color: '#666' }, children: subtitle }), children] }) }) }));
};
export default AuthLayout;
// Minimal placeholder to satisfy imports in consumer apps until dedicated forms are added here
export const RegisterForm = () => {
    return (_jsx("div", { style: { padding: 24 }, children: _jsx("h3", { children: "Register" }) }));
};
//# sourceMappingURL=AuthLayout.js.map